import { extractJwtField } from '../validator/JwtDecoder';

// Interface para o retorno quando NÃO está logado
interface AuthStateLoggedOut {
  isLoggedIn: false;
  profileId: null;
  name: null;
  email: null;
  personId: null;
  isLoading: false;
  isAdmin: false;
  isAgrinhoIngles: false;
  isUserEventSystem: false;
  expiresAt: null;
}

// Interface para o retorno quando ESTÁ logado
interface AuthStateLoggedIn {
  isLoggedIn: true;
  profileId: string | number;
  name: string;
  email: string;
  personId: number | string;
  isLoading: false;
  isAdmin: boolean;
  isAgrinhoIngles: boolean;
  isUserEventSystem: boolean;
  expiresAt: string | number;
}

// Union type para o retorno da função
export type AuthState = AuthStateLoggedOut | AuthStateLoggedIn;

// Helper para extrair string
const extractString = (token: string, field: string): string | null => {
  const value = extractJwtField(token, field);
  if (value === undefined || value === null) return null;
  return String(value);
};

// Helper para extrair string ou number
const extractField = (token: string, field: string): string | number | null => {
  const value = extractJwtField(token, field);
  if (value === undefined || value === null) return null;
  return value as string | number;
};

export const getAuth = (): AuthState => {
  const token = localStorage.getItem('accessToken');

  if (!token) {
    return {
      isLoggedIn: false,
      profileId: null,
      name: null,
      email: null,
      isLoading: false,
      isAdmin: false,
      isAgrinhoIngles: false,
      isUserEventSystem: false,
      expiresAt: null,
      personId: null,
    };
  }

  try {
    const personId = extractField(token, 'sid');
    const profileId = extractField(token, 'RoleId');
    const name = extractString(token, 'sub');
    const email = extractString(token, 'email');
    const expiresAt = extractField(token, 'exp');

    // Verifica se o token expirou
    const isExpired = expiresAt ? Date.now() / 1000 > Number(expiresAt) : false;

    // Valida se todos os campos obrigatórios existem, incluindo personId
    if (isExpired || !profileId || !name || !email || !expiresAt || !personId) {
      return {
        personId: null,
        isLoggedIn: false,
        profileId: null,
        name: null,
        email: null,
        isLoading: false,
        isAdmin: false,
        isAgrinhoIngles: false,
        isUserEventSystem: false,
        expiresAt: null,
      };
    }

    const isAdmin = profileId === '1' || profileId === 1;
    const isUserEventSystem = profileId === '2' || profileId === 2;
    const isAgrinhoIngles = profileId === '3' || profileId === 3;

    return {
      isLoggedIn: true,
      profileId,
      name,
      email,
      isLoading: false,
      isAdmin,
      expiresAt,
      isUserEventSystem,
      isAgrinhoIngles,
      personId,
    };
  } catch (error) {
    console.error('Erro ao decodificar token:', error);
    return {
      isLoggedIn: false,
      profileId: null,
      name: null,
      email: null,
      isLoading: false,
      isAdmin: false,
      isAgrinhoIngles: false,
      isUserEventSystem: false,
      expiresAt: null,
      personId: null,
    };
  }
};

export const useAuth = (): AuthState => {
  return getAuth();
};
